import React from 'react'
import { Link } from 'react-router-dom'
import MessageUI from './MessageUI'
import './EmptyList.css'

const EmptyListUI = ({messageList, className, createEnabled,
    // either createLink or onCreateClick is needed not both
    createLink, onCreateClick, createLinkKey, createEnabledMessageKey,
    createDisabledMessageKey, createDisabledMessageLabel, label
  }) =>
  <div className={`w_empty_list ${className ? className : ''}`}>
    <div className='inner'>
    {
      !createEnabled &&
      <React.Fragment>
        {
          createDisabledMessageLabel &&
          <span>{createDisabledMessageLabel}</span>
        }
        {
          createDisabledMessageKey &&
          <MessageUI messageList={messageList} messageKey={createDisabledMessageKey} label={label}/>
        }
      </React.Fragment>
    }
    {
      createEnabled &&
      <React.Fragment>
        {
          createLink &&
          <Link to={createLink}>
            <div className='icon icon-plus' />
            <MessageUI messageList={messageList} messageKey={createLinkKey} label={label}/>
          </Link>
        }
        {
          onCreateClick &&
          <div className='g_link' onClick={onCreateClick}>
            <div className='icon icon-plus' />
            <MessageUI messageList={messageList} messageKey={createLinkKey} label={label}/>
          </div>
        }
        {
          createEnabledMessageKey &&
          <div className='mesg'>
            <MessageUI messageList={messageList} messageKey={createEnabledMessageKey} label={label}/>
          </div>
        }
      </React.Fragment>
    }
    </div>
  </div>

export default EmptyListUI
